<template>
	<button @click="toggle">
		<i class="fal" :class="muted ? 'fa-volume-slash' : 'fa-volume-up'" />
	</button>
</template>

<script>
export default {
	props: ['muted', 'player'],
	methods: {
		toggle() {
			let player = this.player
			player.volume = this.muted ? 1 : 0
			player.muted = !this.muted
		},
	}
}
</script>
